import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Local from "model/patrimonio/Local";
import Patrimonio from "model/patrimonio/Patrimonio";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class PatrimonioService implements BaseServiceCadastros<Patrimonio> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/patrimonio/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Patrimonio>((resolve, reject): void => {
            api
                .get(`/patrimonio/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(data: FormData) {
        return new Promise<Patrimonio>((resolve, reject): void => {
            apiFile
                .post(`/patrimonio/incluir`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(data: FormData) {
        return new Promise<Patrimonio>((resolve, reject): void => {
            apiFile
                .put(`/patrimonio/editar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/patrimonio/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/patrimonio/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtosPatrimoniaveis() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/patrimonio/produtosPatrimoniaveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    locais() {
        return new Promise<Local[]>((resolve, reject): void => {
            api
                .get(`/patrimonio/locais`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    fornecedores() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/patrimonio/fornecedores`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    mudarLocal( id: number, local: Local){
        return new Promise<Local>((resolve, reject): void => {
            api
                .put(`/patrimonio/mudarLocal/${id}`, JSON.stringify(local))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    inutilizar(patrimonio: Patrimonio){
        return new Promise<Patrimonio>((resolve, reject): void => {
            api
                .put(`/patrimonio/inutilizar`, JSON.stringify(patrimonio))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    descartar( id: number){
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/patrimonio/descartar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    disponibilizar( id: number){
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/patrimonio/disponibilizar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaStatus() {

        return [
            { value: "DISPONIVEL", label: "Disponível" },
            { value: "EM_USO", label: "Em uso" },
            { value: "DESCARTADO", label: "Descartado" },
            { value: "AGUARDANDO_DESCARTE", label: "Aguardando Descarte" }
        ];
    }

    getStatus(status: string) {
        return this.getListaStatus().find(item => item.value === status)?.label || "";
    }

    getListaStatusFilter() {
        return [
            { label: "Disponível", value: "D" },
            { label: "Em uso", value: "E" },
            { label: "Descartado", value: "C" },
            { label: "Aguardando Descarte", value: "A" }
        ]
    }

    getRelatorioListagem(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/patrimonio/report/listagem`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    getRelatorio(id : number) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/patrimonio/report/${id}`;
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default PatrimonioService;